// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CarCardClient_wrapper__Vx9re"};